import { pageBreadcrumbStyles } from "@insite/content-library/Components/PageBreadcrumbs";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

pageBreadcrumbStyles.breadcrumbs = {
    typographyProps: {
        css: css`
            color: ${getColor("text.main")} !important;
        `,
        size: 15,
    }
}